/**
 * External Dependencies
 */
import Icon from '@/common/icon/icon';
import cx from 'classnames';

const Badge = ({ className, children, type, color, size, rounded, alt, baseStyling, dot, icon }) => {
    return (
        <div
            className={cx('badge', className, {
                [`badge--${color}`]: color,
                [`badge--${type}`]: type,
                [`badge--${size}`]: size,
                'badge--rounded': rounded,
                'badge--alt': alt,
                'badge--base-styling': baseStyling,
            })}
        >
            {icon && <Icon name={icon} />}

            {dot && <div className="badge__dot" />}

            {children}
        </div>
    );
};

export default Badge;
